import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/bar-2.svg'


const _withScopeId = n => (_pushScopeId("data-v-5839669e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-4" }
const _hoisted_3 = { class: "d-flex justify-content-end mb-4 wrapper-button" }
const _hoisted_4 = {
  key: 0,
  class: "d-lg-flex"
}
const _hoisted_5 = { class: "mx-lg-4 d-flex align-items-center" }
const _hoisted_6 = {
  key: 1,
  class: "table-responsive table-responsive-viewport"
}
const _hoisted_7 = { class: "table table-borderless" }
const _hoisted_8 = { class: "align-middle text-center" }
const _hoisted_9 = { class: "border-top-radius" }
const _hoisted_10 = { class: "border-left-radius" }
const _hoisted_11 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "edit",
  class: "me-2 cursor-pointer drag-handle"
}, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_17 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_18 = {
  key: 1,
  class: "fw-bold"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen color-edit" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-danger" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 2,
  class: "text-center fw-bold"
}
const _hoisted_26 = {
  key: 3,
  class: "d-lg-flex"
}
const _hoisted_27 = { class: "mx-lg-4 d-flex align-items-center" }
const _hoisted_28 = {
  class: "modal fade",
  id: "editModal",
  tabindex: "-1",
  "aria-labelledby": "editModal",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "modal-dialog" }
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = { class: "modal-header mb-3" }
const _hoisted_32 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_34 = ["onSubmit"]
const _hoisted_35 = { class: "mx-4 mb-4" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-lg-6 col-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_40 = { class: "col-lg-6 col-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_41 = {
  class: "modal fade",
  id: "confirmModal",
  tabindex: "-1",
  "aria-labelledby": "confirmModal",
  "aria-hidden": "true"
}
const _hoisted_42 = { class: "modal-dialog modal-dialog--small" }
const _hoisted_43 = { class: "modal-content" }
const _hoisted_44 = { class: "modal-header mb-3" }
const _hoisted_45 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_47 = { class: "text-center fs-6 mb-4" }
const _hoisted_48 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_49 = {
  class: "modal fade",
  id: "finishModal",
  tabindex: "-1",
  "aria-labelledby": "finishModal",
  "aria-hidden": "true"
}
const _hoisted_50 = { class: "modal-dialog" }
const _hoisted_51 = { class: "modal-content" }
const _hoisted_52 = { class: "modal-header mb-3" }
const _hoisted_53 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_55 = { class: "text-center fs-6 mb-4" }
const _hoisted_56 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_57 = {
  class: "modal fade",
  id: "createModal",
  tabindex: "-1",
  "aria-labelledby": "createModal",
  "aria-hidden": "true"
}
const _hoisted_58 = { class: "modal-dialog" }
const _hoisted_59 = { class: "modal-content" }
const _hoisted_60 = { class: "modal-header mb-3" }
const _hoisted_61 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_63 = ["onSubmit"]
const _hoisted_64 = { class: "mb-4 mx-4" }
const _hoisted_65 = ["placeholder"]
const _hoisted_66 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-lg-6 col-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_69 = { class: "col-lg-6 col-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_70 = {
  class: "modal fade",
  id: "confirmModalCreate",
  tabindex: "-1",
  "aria-labelledby": "confirmModalCreate",
  "aria-hidden": "true"
}
const _hoisted_71 = { class: "modal-dialog modal-dialog--small" }
const _hoisted_72 = { class: "modal-content" }
const _hoisted_73 = { class: "modal-header mb-3" }
const _hoisted_74 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_76 = { class: "text-center fs-6 mb-4" }
const _hoisted_77 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_78 = {
  class: "modal fade",
  id: "finishModalCreate",
  tabindex: "-1",
  "aria-labelledby": "finishModalCreate",
  "aria-hidden": "true"
}
const _hoisted_79 = { class: "modal-dialog" }
const _hoisted_80 = { class: "modal-content" }
const _hoisted_81 = { class: "modal-header mb-3" }
const _hoisted_82 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_84 = { class: "text-center fs-6 mb-4" }
const _hoisted_85 = { class: "d-flex justify-content-center modal-footer" }

import { ref, computed, onMounted, ComputedRef, watch } from 'vue'
import { useStore } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useRoute, useRouter } from 'vue-router'
// import dayjs from 'dayjs'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'

import Button from '@/components/button/index.vue'
import Pagination from '@/components/pagination/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import ModalDelete from './components/ModalDelete.vue'
import Draggable from 'vuedraggable'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import communityManagerServices from '@/services/community-managers.services'
import Loading from '@/components/loading/index.vue'
import ErrorMessage from '@/components/error-message/index.vue'
import { USER_MANAGEMENT_STORE } from '@/store/constants'
import { translate } from '@/languages/i18n'
import TotalRecords from '@/components/total-records/index.vue'
import { customMaxLength, customMinLength } from '@/utils'
import { useToast } from 'vue-toastification'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const toast = useToast()

const idUser = ref('')
const userName = ref('')
const createFailed = ref<boolean>(false)
const editFailed = ref<boolean>(false)
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/${route.path.split('/')[1]}/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('configuration'),
    to: '',
    active: false,
  },
  {
    content: translate('CN10title'),
    to: '',
    active: true,
  },
]
const store = useStore()
const userFlag = computed(() => store.getters[USER_MANAGEMENT_STORE.GETTERS.USER_FLAG_DATA]?.userFlagData)
const loading = computed(() => store.getters[USER_MANAGEMENT_STORE.GETTERS.USER_FLAG_DATA]?.loading)
const loadingCreate = ref(false)
const loadingEdit = ref(false)
const userFlagList = ref<any[]>([])
const drag = ref(false)
let lastMouseY = -1
let dragInterval: any = null

const handleDragOver = (e: DragEvent) => {
  lastMouseY = e.clientY
}

const handleTouchMove = (e: TouchEvent) => {
  if (e.touches && e.touches.length > 0) {
    lastMouseY = e.touches[0].clientY
  }
}

const onDragStart = () => {
  drag.value = true
  lastMouseY = -1
  window.addEventListener('dragover', handleDragOver)
  window.addEventListener('touchmove', handleTouchMove)

  // Cache the thead bottom position once at start to avoid layout reflow/thrashing during scroll loop
  const theadEl = document.querySelector('thead') as HTMLElement
  const cachedTheadBottom = theadEl ? theadEl.getBoundingClientRect().bottom : 130

  const checkScroll = () => {
    if (!drag.value) return

    if (lastMouseY !== -1) {
      if (lastMouseY <= cachedTheadBottom + 90) {
        window.scrollBy(0, -12) // Smooth scroll speed
      } else if (window.innerHeight - lastMouseY <= 40) {
        window.scrollBy(0, 12)
      }
    }

    dragInterval = requestAnimationFrame(checkScroll)
  }

  dragInterval = requestAnimationFrame(checkScroll)
}

const onDragEnd = async (event: any) => {
  window.removeEventListener('dragover', handleDragOver)
  window.removeEventListener('touchmove', handleTouchMove)
  if (dragInterval) {
    cancelAnimationFrame(dragInterval)
    dragInterval = null
  }

  const { newIndex, oldIndex } = event

  if (newIndex === oldIndex) {
    drag.value = false
    return
  }

  const draggedItem = userFlagList.value[newIndex]
  const prevItem = newIndex > 0 ? userFlagList.value[newIndex - 1] : null
  const nextItem = newIndex < userFlagList.value.length - 1 ? userFlagList.value[newIndex + 1] : null

  const payload = {
    drag_id: draggedItem.id,
    prev_id: prevItem ? prevItem.id : null,
    next_id: nextItem ? nextItem.id : null,
  }

  try {
    const communityId = route.params?.id as string
    const response = await communityManagerServices.sortUserManagerFlags(communityId, payload)

    if (response.status !== 200) {
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'MSG_CHANGE_DISPLAY_ORDER_FAILED',
        },
      })
    }
  } catch (error) {
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: 'MSG_CHANGE_DISPLAY_ORDER_FAILED',
      },
    })
  } finally {
    drag.value = false
  }
}

const sortDisplay = (index: number) => {
  const page = Number(route.query.page ?? 1)
  const perPage = Number(route.query.page_of_number ?? dataSelectRecordPerPage.value[0].value)

  return (page - 1) * perPage + index + 1
}

watch(
  () => userFlag.value?.data,
  (newData) => {
    if (newData) {
      userFlagList.value = [...newData]
    }
  },
  { immediate: true }
)
// 2022/10/03 CW-Phuong Fix for UAT Phase1#3984: CN10 (Ph1-R20221005)
const validateCreateFlags = ref('')
const validateEditFlags = ref('')
const modalCreate = ref()
const modalConfirmCreate = ref()
const modalFinishCreate = ref()
const modalEdit = ref()
const modalConfirmEdit = ref()
const modalFinishEdit = ref()

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

const dataEdit = ref({
  name: '',
})
// 2022/10/03 CW-Phuong Fix for UAT Phase1#3984: CN10 (Ph1-R20221005)
onMounted(() => {
  modalCreate.value = new Modal(document.getElementById('createModal'))
  modalConfirmCreate.value = new Modal(document.getElementById('confirmModalCreate'))
  modalFinishCreate.value = new Modal(document.getElementById('finishModalCreate'))

  modalEdit.value = new Modal(document.getElementById('editModal'))
  modalConfirmEdit.value = new Modal(document.getElementById('confirmModal'))
  modalFinishEdit.value = new Modal(document.getElementById('finishModal'))
})

watch(
  () => route.query,
  () => {
    const payload = {
      id: route.params?.id,
      params: {
        ...route.query,
        page: route.query?.page || '1',
        page_of_number: route.query?.page_of_number || dataSelectRecordPerPage.value[0].value,
      },
    }
    store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.SET_USER_FLAG_DATA, payload)
  },
  { immediate: true }
)

const setCurrentData = (id: any, name: string): void => {
  idUser.value = id
  dataEdit.value = { name: name }
  userName.value = name
  changeFlag()
}
const rulesEdit = computed(() => {
  return {
    name: {
      required,
      maxLength: (value: string) => customMaxLength(value, 20),
      minLength: (value: string) => customMinLength(value, 1),
    },
  }
})
const v$ = useVuelidate(rulesEdit, dataEdit)
const submitEdit = (): void => {
  v$.value.$touch()
  if (v$.value.$invalid) {
    return
  }
}
const dataCreate = ref({
  name: '',
})
const rulesCreate = computed(() => {
  return {
    name: {
      required,
      maxLength: (value: string) => customMaxLength(value, 20),
      minLength: (value: string) => customMinLength(value, 1),
    },
  }
})
const create_v$ = useVuelidate(rulesCreate, dataCreate)
const submitCreate = (): void => {
  create_v$.value.$touch()
  if (create_v$.value.$invalid) {
    return
  }
}
//22022/10/06 CW-Phuong Fix-for-resolve-conflict
// 2022/09/12 TienNV Fix double click button confirm
// const modalConfirm = ref()
// const modalSuccess = ref()
// const modalConfirmEdit = ref()
// const modalSuccessEdit = ref()

// onMounted(() => {
//   modalConfirm.value = new Modal(document.getElementById('confirmModalCreate'))
//   modalSuccess.value = new Modal(document.getElementById('finishModalCreate'))
//   modalConfirmEdit.value = new Modal(document.getElementById('confirmModal'))
//   modalSuccessEdit.value = new Modal(document.getElementById('finishModal'))
// })

const CreateUser = async () => {
  const payload = {
    id: route.params?.id,
    params: {
      ...route.query,
      page: route.query?.page || '1',
      page_of_number: route.query?.page_of_number || dataSelectRecordPerPage.value[0].value,
    },
  }
  loadingCreate.value = true
  try {
    const response = await communityManagerServices.createUserManagerFlags(route?.params?.id, dataCreate.value)
    if (response?.data?.success) {
      store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.SET_USER_FLAG_DATA, payload)
      createFailed.value = false
      loadingCreate.value = false
      // 2022/10/03 CW-Phuong Fix for UAT Phase1#3984: CN10 (Ph1-R20221005)
      modalFinishCreate.value.show()
      modalConfirmCreate.value.hide()
    } else {
      validateCreateFlags.value = response?.response?.data?.data[0]?.message_code
      createFailed.value = true
      loadingCreate.value = false
      modalCreate.value.show()
      modalFinishCreate.value.hide()
      modalConfirmCreate.value.hide()
    }
    //22022/10/06 CW-Phuong Fix-for-resolve-conflict
    // 2022/09/12 TienNV Fix Failed to delete but successful modal is displayed
    // modalConfirm.value.hide()
    // modalSuccess.value.show()
    // setTimeout(() => {
    //   loadingCreate.value = false
    // }, 2000)
  } catch (error) {
    console.log(error)
    createFailed.value = true
    // modalConfirm.value.hide()
    // modalSuccess.value.show()
  }
  loadingCreate.value = false
}
const resetForm = () => {
  create_v$.value.$reset()
  Object.assign(dataCreate.value, {
    name: '',
  })
  changeFlag()
}
const EditUser = async () => {
  loadingEdit.value = true
  const payload = {
    id: route.params?.id,
    params: {
      ...route.query,
      page: route.query?.page || '1',
      page_of_number: route.query?.page_of_number || dataSelectRecordPerPage.value[0].value,
    },
  }
  try {
    const response = await communityManagerServices.editUserManagerFlags(idUser.value, dataEdit.value)
    if (response?.data?.success) {
      store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.SET_USER_FLAG_DATA, payload)
      editFailed.value = false
      // 2022/10/03 CW-Phuong Fix for UAT Phase1#3984: CN10 (Ph1-R20221005)
      modalFinishEdit.value.show()
      modalConfirmEdit.value.hide()
    } else {
      validateEditFlags.value = response?.response?.data?.data[0]?.message_code
      editFailed.value = true
      modalEdit.value.show()
      modalFinishEdit.value.hide()
      modalConfirmEdit.value.hide()
    }
    //22022/10/06 CW-Phuong Fix-for-resolve-conflict
    // modalConfirmEdit.value.hide()
    // modalSuccessEdit.value.show()
    // setTimeout(() => {
    //   loadingEdit.value = false
    // }, 2000)
  } catch (error) {
    console.log(error)
    editFailed.value = true
    // modalConfirmEdit.value.hide()
    // modalSuccessEdit.value.show()
  }
  loadingEdit.value = false
}
// 2022/10/03 CW-Phuong Fix for UAT Phase1#3984: CN10 (Ph1-R20221005)
const changeFlag = () => {
  validateCreateFlags.value = ''
  validateEditFlags.value = ''
}
// 2022/11/29 CW-Phuong Fix for UAT#5447: CN10 (Ph2-R20221222)
const imgSrc: ComputedRef<string> = computed(() => require('@/assets/images/user-attribute-orange.svg'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('CN10title')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Button, {
          title: _unref(translate)('CN10create'),
          type: 'secondary',
          className: 'px-md-5',
          dataBsToggle: 'modal',
          dataBsTarget: '#createModal',
          onClick: resetForm
        }, null, 8, ["title"])
      ]),
      _createVNode(TotalRecords, {
        totalRecords: _unref(userFlag)?.total_records
      }, null, 8, ["totalRecords"]),
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(Pagination, {
                totalPage: _unref(userFlag)?.total_pages,
                totalDataOfPage: _unref(userFlag)?.data?.length,
                changDelete: true
              }, null, 8, ["totalPage", "totalDataOfPage"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_8, [
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_unref(translate)('indicatesOrder')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(translate)('CN10name')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(translate)('managementNo')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(translate)('registrants')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(translate)('registrationDate')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(translate)('edit')), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(translate)('delete')), 1)
                ])
              ]),
              _createVNode(_unref(Draggable), {
                modelValue: userFlagList.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userFlagList).value = $event)),
                tag: "tbody",
                animation: 200,
                handle: ".drag-handle",
                "item-key": "id",
                onStart: onDragStart,
                onEnd: onDragEnd
              }, {
                item: _withCtx(({ element: item, index }) => [
                  _createElementVNode("tr", {
                    class: _normalizeClass(["align-middle text-center", { rowEven: index % 2 === 0 }])
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("span", null, _toDisplayString(sortDisplay(index)), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.name || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(item.management_no || '-'), 1),
                    (item?.is_deleted_in_30_days === 2)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                          _createElementVNode("img", {
                            src: _unref(imgSrc),
                            alt: "user attribute",
                            class: "me-2 icon-user"
                          }, null, 8, _hoisted_14),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(translate)('SO10user31_new')), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_16, [
                          _createVNode(UserAliasIcon, {
                            title: item?.family_name,
                            titleOther: item?.given_name,
                            userType: item?.is_admin ? 3 : 1
                          }, null, 8, ["title", "titleOther", "userType"]),
                          (item?.available === false)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(translate)('OE12pause')), 1))
                            : (item?.is_deleted_in_30_days === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(translate)('SO10user30')), 1))
                              : _createCommentVNode("", true)
                        ])),
                    _createElementVNode("td", null, _toDisplayString(_unref(ConvertFromLocalTime)(item?.created_at)), 1),
                    _createElementVNode("td", {
                      class: _normalizeClass(['cursor-pointer']),
                      "data-bs-Toggle": "modal",
                      "data-bs-target": "#editModal",
                      onClick: ($event: any) => (setCurrentData(item.id, item.name))
                    }, _hoisted_21, 8, _hoisted_19),
                    _createElementVNode("td", {
                      class: "cursor-pointer",
                      "data-bs-Toggle": "modal",
                      "data-bs-target": "#deleteTag",
                      onClick: ($event: any) => (setCurrentData(item.id, item.name))
                    }, _hoisted_24, 8, _hoisted_22)
                  ], 2)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(userFlag)?.data?.length === 0 && !_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(translate)('CC40noData')), 1))
        : _createCommentVNode("", true),
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", null, [
              _createVNode(Pagination, {
                totalPage: _unref(userFlag)?.total_pages,
                totalDataOfPage: _unref(userFlag)?.data?.length,
                changDelete: true
              }, null, 8, ["totalPage", "totalDataOfPage"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("h5", _hoisted_32, _toDisplayString(_unref(translate)('CN10confirmModalEdit')), 1),
            _hoisted_33
          ]),
          _createElementVNode("form", {
            onSubmit: _withModifiers(submitEdit, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_35, [
              _withDirectives(_createElementVNode("input", {
                type: "name",
                class: _normalizeClass(['form-control', _unref(v$).name.$error ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                placeholder: _unref(translate)('placeholder'),
                onKeyup: changeFlag
              }, null, 42, _hoisted_36), [
                [
                  _vModelText,
                  _unref(v$).name.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('CN10name'),
                validator: _unref(v$).name.$errors[0]?.$validator,
                params: [1, 20]
              }, null, 8, ["title", "validator"])
            ]),
            (validateEditFlags.value === 'VALIDATE_DUPLICATE')
              ? (_openBlock(), _createBlock(ErrorMessage, {
                  key: 0,
                  title: _unref(translate)('CN10validatDuplicate')
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    class: "m-w-unset",
                    "data-bs-dismiss": "modal"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(Button, {
                    title: _unref(translate)('confirm'),
                    type: 'secondary',
                    dataBsToggle: _unref(v$).$invalid ? '' : 'modal',
                    dataBsTarget: _unref(v$).$invalid ? '' : '#confirmModal'
                  }, null, 8, ["title", "dataBsToggle", "dataBsTarget"])
                ])
              ])
            ])
          ], 40, _hoisted_34)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("h5", _hoisted_45, _toDisplayString(_unref(translate)('CN10confirmModalEdit')), 1),
            _hoisted_46
          ]),
          _createElementVNode("h4", _hoisted_47, "「" + _toDisplayString(dataEdit.value.name) + "」 " + _toDisplayString(_unref(translate)('CN10editConfirm')), 1),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(Button, {
              title: _unref(translate)('titleButtonEdit'),
              type: 'secondary',
              dataBsToggle: 'modal',
              dataBsTarget: '#editModal',
              className: 'me-2'
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: _unref(translate)('update'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              onClick: EditUser
            }, null, 8, ["title"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("h5", _hoisted_53, _toDisplayString(_unref(translate)('CN10confirmModalEdit')), 1),
            _hoisted_54
          ]),
          _createElementVNode("h4", _hoisted_55, "「" + _toDisplayString(dataEdit.value.name) + "」 " + _toDisplayString(editFailed.value ? _unref(translate)('CN10editFailed') : _unref(translate)('CN10editSuccess')), 1),
          _createElementVNode("div", _hoisted_56, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ]),
    _createVNode(ModalDelete, {
      userId: idUser.value,
      userName: userName.value
    }, null, 8, ["userId", "userName"]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("h5", _hoisted_61, _toDisplayString(_unref(translate)('CN10titleCreate')), 1),
            _hoisted_62
          ]),
          _createElementVNode("form", {
            onSubmit: _withModifiers(submitCreate, ["prevent"]),
            class: ""
          }, [
            _createElementVNode("div", _hoisted_64, [
              _withDirectives(_createElementVNode("input", {
                type: "name",
                class: _normalizeClass(['form-control', _unref(create_v$).name.$error ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(create_v$).name.$model) = $event)),
                placeholder: _unref(translate)('placeholder'),
                onKeyup: changeFlag
              }, null, 42, _hoisted_65), [
                [
                  _vModelText,
                  _unref(create_v$).name.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('CN10name'),
                validator: _unref(create_v$).name.$errors[0]?.$validator,
                params: [1, 20]
              }, null, 8, ["title", "validator"])
            ]),
            (validateCreateFlags.value === 'VALIDATE_DUPLICATE')
              ? (_openBlock(), _createBlock(ErrorMessage, {
                  key: 0,
                  title: _unref(translate)('CN10validatDuplicate')
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    class: "m-w-unset",
                    "data-bs-dismiss": "modal"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(Button, {
                    title: _unref(translate)('confirm'),
                    type: 'secondary',
                    dataBsToggle: _unref(create_v$).$invalid ? '' : 'modal',
                    dataBsTarget: _unref(create_v$).$invalid ? '' : '#confirmModalCreate'
                  }, null, 8, ["title", "dataBsToggle", "dataBsTarget"])
                ])
              ])
            ])
          ], 40, _hoisted_63)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_70, [
      _createElementVNode("div", _hoisted_71, [
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("h5", _hoisted_74, _toDisplayString(_unref(translate)('CN10titleCreate')), 1),
            _hoisted_75
          ]),
          _createElementVNode("h4", _hoisted_76, "「" + _toDisplayString(dataCreate.value.name) + "」 " + _toDisplayString(_unref(translate)('CN10createConfirm')), 1),
          _createElementVNode("div", _hoisted_77, [
            _createVNode(Button, {
              title: _unref(translate)('titleButtonEdit'),
              type: 'secondary',
              dataBsToggle: 'modal',
              dataBsTarget: '#createModal',
              className: 'me-2'
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: _unref(translate)('signUp'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              onClick: CreateUser,
              loading: loadingCreate.value,
              disabled: loadingCreate.value
            }, null, 8, ["title", "loading", "disabled"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_78, [
      _createElementVNode("div", _hoisted_79, [
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("h5", _hoisted_82, _toDisplayString(_unref(translate)('CN10titleCreate')), 1),
            _hoisted_83
          ]),
          _createElementVNode("h4", _hoisted_84, "「" + _toDisplayString(dataCreate.value.name) + "」" + _toDisplayString(createFailed.value ? _unref(translate)('CN10createFailed') : _unref(translate)('CN10createSuccess')), 1),
          _createElementVNode("div", _hoisted_85, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ]),
    _createVNode(Loading, { loading: _unref(loading) }, null, 8, ["loading"])
  ], 64))
}
}

})